import type { Country } from '@base/types'

const countries: Country[] = [
  // {
  //   code2: 'AF',
  //   code3: 'AFG',
  //   currency: 'USD',
  //   phoneCode: '+93',
  //   name: 'Afghanistan',
  //   native: 'افغانستان',
  //   vat: 10,
  // },
  {
    code2: 'AL',
    code3: 'ALB',
    currency: 'EUR',
    phoneCode: '+355',
    name: 'Albania',
    native: 'Shqipëria',
    vat: 20,
  },
  {
    code2: 'DZ',
    code3: 'DZA',
    currency: 'USD',
    phoneCode: '+213',
    name: 'Algeria',
    native: 'الجزائر',
    vat: 19,
  },
  {
    code2: 'AS',
    code3: 'ASM',
    currency: 'USD',
    phoneCode: '+1',
    name: 'American Samoa',
    native: 'American Samoa',
    vat: 15,
  },
  {
    code2: 'AD',
    code3: 'AND',
    currency: 'EUR',
    phoneCode: '+376',
    name: 'Andorra',
    native: 'Andorra',
    vat: 4.5,
  },
  {
    code2: 'AO',
    code3: 'AGO',
    currency: 'USD',
    phoneCode: '+244',
    name: 'Angola',
    native: 'Angola',
    vat: 14,
  },
  {
    code2: 'AG',
    code3: 'ATG',
    currency: 'USD',
    phoneCode: '+1',
    name: 'Antigua and Barbuda',
    native: 'Antigua and Barbuda',
    vat: 15,
  },
  {
    code2: 'AR',
    code3: 'ARG',
    currency: 'USD',
    phoneCode: '+54',
    name: 'Argentina',
    native: 'Argentina',
    vat: 21,
  },
  {
    code2: 'AM',
    code3: 'ARM',
    currency: 'USD',
    phoneCode: '+374',
    name: 'Armenia',
    native: 'Հայաստան',
    vat: 20,
  },
  {
    code2: 'AW',
    code3: 'ABW',
    currency: 'USD',
    phoneCode: '+297',
    name: 'Aruba',
    native: 'Aruba',
    vat: 2,
  },
  {
    code2: 'AU',
    code3: 'AUS',
    currency: 'USD',
    phoneCode: '+61',
    name: 'Australia',
    native: 'Australia',
    vat: 10,
  },
  {
    code2: 'AT',
    code3: 'AUT',
    currency: 'EUR',
    phoneCode: '+43',
    name: 'Austria',
    native: 'Österreich',
    vat: 20,
  },
  {
    code2: 'AZ',
    code3: 'AZE',
    currency: 'USD',
    phoneCode: '+994',
    name: 'Azerbaijan',
    native: 'Azərbaycan',
    vat: 18,
  },
  {
    code2: 'BS',
    code3: 'BHS',
    currency: 'USD',
    phoneCode: '+1',
    name: 'Bahamas',
    native: 'Bahamas',
    vat: 12,
  },
  {
    code2: 'BH',
    code3: 'BHR',
    currency: 'USD',
    phoneCode: '+973',
    name: 'Bahrain',
    native: '‏البحرين',
    vat: 10,
  },
  {
    code2: 'BD',
    code3: 'BGD',
    currency: 'USD',
    phoneCode: '+880',
    name: 'Bangladesh',
    native: 'Bangladesh',
    vat: 15,
  },
  // {
  //   code2: 'BB',
  //   code3: 'BRB',
  //   currency: 'USD',
  //   phoneCode: '+1',
  //   name: 'Barbados',
  //   native: 'Barbados',
  //   vat: 17.5,
  // },
  {
    code2: 'BY',
    code3: 'BLR',
    currency: 'USD',
    phoneCode: '+375',
    name: 'Belarus',
    native: 'Белару́сь',
    vat: 20,
  },
  {
    code2: 'BE',
    code3: 'BEL',
    currency: 'EUR',
    phoneCode: '+32',
    name: 'Belgium',
    native: 'België',
    vat: 21,
  },
  {
    code2: 'BZ',
    code3: 'BLZ',
    currency: 'USD',
    phoneCode: '+501',
    name: 'Belize',
    native: 'Belize',
    vat: 12.5,
  },
  {
    code2: 'BJ',
    code3: 'BEN',
    currency: 'USD',
    phoneCode: '+229',
    name: 'Benin',
    native: 'Bénin',
    vat: 18,
  },
  {
    code2: 'BO',
    code3: 'BOL',
    currency: 'USD',
    phoneCode: '+591',
    name: 'Bolivia',
    native: 'Bolivia',
    vat: 13,
  },
  {
    code2: 'BQ',
    code3: 'BES',
    currency: 'USD',
    phoneCode: '+599',
    name: 'Bonaire',
    native: 'Bonaire',
    vat: 8,
  },
  {
    code2: 'BA',
    code3: 'BIH',
    currency: 'EUR',
    phoneCode: '+387',
    name: 'Bosnia and Herzegovina',
    native: 'Bosna i Hercegovina',
    vat: 17,
  },
  {
    code2: 'BW',
    code3: 'BWA',
    currency: 'USD',
    phoneCode: '+267',
    name: 'Botswana',
    native: 'Botswana',
    vat: 14,
  },
  {
    code2: 'BR',
    code3: 'BRA',
    currency: 'USD',
    phoneCode: '+55',
    name: 'Brazil',
    native: 'Brasil',
    vat: 18,
  },
  {
    code2: 'IO',
    code3: 'IOT',
    currency: 'USD',
    phoneCode: '+246',
    name: 'British Indian Ocean Territory',
    native: 'British Indian Ocean Territory',
    vat: 20,
  },
  {
    code2: 'VG',
    code3: 'VGB',
    currency: 'USD',
    phoneCode: '+1',
    name: 'British Virgin Islands',
    native: 'British Virgin Islands',
    vat: 21,
  },
  {
    code2: 'BG',
    code3: 'BGR',
    currency: 'BGN',
    phoneCode: '+359',
    name: 'Bulgaria',
    native: 'България',
    vat: 20,
  },
  // {
  //   code2: 'BF',
  //   code3: 'BFA',
  //   currency: 'USD',
  //   phoneCode: '+226',
  //   name: 'Burkina Faso',
  //   native: 'Burkina Faso',
  //   vat: 18,
  // },
  {
    code2: 'BI',
    code3: 'BDI',
    currency: 'USD',
    phoneCode: '+257',
    name: 'Burundi',
    native: 'Burundi',
    vat: 18,
  },
  {
    code2: 'KH',
    code3: 'KHM',
    currency: 'USD',
    phoneCode: '+855',
    name: 'Cambodia',
    native: 'Kâmpŭchéa',
    vat: 10,
  },
  // {
  //   code2: 'CM',
  //   code3: 'CMR',
  //   currency: 'USD',
  //   phoneCode: '+237',
  //   name: 'Cameroon',
  //   native: 'Cameroon',
  //   vat: 19.25,
  // },
  {
    code2: 'CA',
    code3: 'CAN',
    currency: '',
    phoneCode: '+1',
    name: 'Canada',
    native: 'Canada',
    vat: 5,
  },
  {
    code2: 'CV',
    code3: 'CPV',
    currency: 'USD',
    phoneCode: '+238',
    name: 'Cape Verde',
    native: 'Cabo Verde',
    vat: 15,
  },
  {
    code2: 'CF',
    code3: 'CAF',
    currency: 'USD',
    phoneCode: '+236',
    name: 'Central African Republic',
    native: 'Ködörösêse tî Bêafrîka',
    vat: 19,
  },
  {
    code2: 'TD',
    code3: 'TCD',
    currency: 'USD',
    phoneCode: '+235',
    name: 'Chad',
    native: 'Tchad',
    vat: 18,
  },
  {
    code2: 'CL',
    code3: 'CHL',
    currency: 'USD',
    phoneCode: '+56',
    name: 'Chile',
    native: 'Chile',
    vat: 19,
  },
  {
    code2: 'CN',
    code3: 'CHN',
    currency: 'USD',
    phoneCode: '+86',
    name: 'China',
    native: '中国',
    vat: 13,
  },
  {
    code2: 'CO',
    code3: 'COL',
    currency: 'USD',
    phoneCode: '+57',
    name: 'Colombia',
    native: 'Colombia',
    vat: 19,
  },
  {
    code2: 'KM',
    code3: 'COM',
    currency: 'USD',
    phoneCode: '+269',
    name: 'Comoros',
    native: 'Komori',
    vat: 10,
  },
  {
    code2: 'CK',
    code3: 'COK',
    currency: 'USD',
    phoneCode: '+682',
    name: 'Cook Islands',
    native: 'Cook Islands',
    vat: 15,
  },
  {
    code2: 'CR',
    code3: 'CRI',
    currency: 'USD',
    phoneCode: '+506',
    name: 'Costa Rica',
    native: 'Costa Rica',
    vat: 13,
  },
  {
    code2: 'HR',
    code3: 'HRV',
    currency: 'HRK',
    phoneCode: '+385',
    name: 'Croatia',
    native: 'Hrvatska',
    vat: 25,
  },
  {
    code2: 'CW',
    code3: 'CUW',
    currency: 'USD',
    phoneCode: '+599',
    name: 'Curacao',
    native: 'Curaçao',
    vat: 6,
  },
  {
    code2: 'CY',
    code3: 'CYP',
    currency: 'EUR',
    phoneCode: '+357',
    name: 'Cyprus',
    native: 'Κύπρος',
    vat: 19,
  },
  {
    code2: 'CZ',
    code3: 'CZE',
    currency: 'CZK',
    phoneCode: '+420',
    name: 'Czechia',
    native: 'Česko',
    vat: 21,
    priority: 1,
  },
  // {
  //   code2: 'CD',
  //   code3: 'COD',
  //   currency: 'USD',
  //   phoneCode: '+243',
  //   name: 'Democratic Republic of the Congo',
  //   native: 'République démocratique du Congo',
  //   vat: 18,
  // },
  {
    code2: 'DK',
    code3: 'DNK',
    currency: 'DKK',
    phoneCode: '+45',
    name: 'Denmark',
    native: 'Danmark',
    vat: 25,
  },
  {
    code2: 'DJ',
    code3: 'DJI',
    currency: 'USD',
    phoneCode: '+253',
    name: 'Djibouti',
    native: 'Djibouti',
    vat: 10,
  },
  {
    code2: 'DM',
    code3: 'DMA',
    currency: 'USD',
    phoneCode: '+1',
    name: 'Dominica',
    native: 'Dominica',
    vat: 15,
  },
  {
    code2: 'DO',
    code3: 'DOM',
    currency: 'USD',
    phoneCode: '+809',
    name: 'Dominican Republic',
    native: 'República Dominicana',
    vat: 18,
  },
  {
    code2: 'TL',
    code3: 'TLS',
    currency: 'USD',
    phoneCode: '+670',
    name: 'East Timor',
    native: 'Timor-Leste',
    vat: 10,
  },
  {
    code2: 'EC',
    code3: 'ECU',
    currency: 'USD',
    phoneCode: '+593',
    name: 'Ecuador',
    native: 'Ecuador',
    vat: 12,
  },
  {
    code2: 'EG',
    code3: 'EGY',
    currency: 'USD',
    phoneCode: '+20',
    name: 'Egypt',
    native: 'مصر‎',
    vat: 14,
  },
  {
    code2: 'SV',
    code3: 'SLV',
    currency: 'USD',
    phoneCode: '+503',
    name: 'El Salvador',
    native: 'El Salvador',
    vat: 13,
  },
  {
    code2: 'GQ',
    code3: 'GNQ',
    currency: 'USD',
    phoneCode: '+240',
    name: 'Equatorial Guinea',
    native: 'Guinea Ecuatorial',
    vat: 15,
  },
  {
    code2: 'ER',
    code3: 'ERI',
    currency: 'USD',
    phoneCode: '+291',
    name: 'Eritrea',
    native: 'ኤርትራ',
    vat: 5,
  },
  {
    code2: 'EE',
    code3: 'EST',
    currency: 'EUR',
    phoneCode: '+372',
    name: 'Estonia',
    native: 'Eesti',
    vat: 20,
  },
  {
    code2: 'ET',
    code3: 'ETH',
    currency: 'USD',
    phoneCode: '+251',
    name: 'Ethiopia',
    native: 'ኢትዮጵያ',
    vat: 15,
  },
  {
    code2: 'FO',
    code3: 'FRO',
    currency: 'USD',
    phoneCode: '+298',
    name: 'Faroe Islands',
    native: 'Føroyar',
    vat: 25,
  },
  {
    code2: 'FJ',
    code3: 'FJI',
    currency: 'USD',
    phoneCode: '+679',
    name: 'Fiji',
    native: 'Fiji',
    vat: 9,
  },
  {
    code2: 'FI',
    code3: 'FIN',
    currency: 'EUR',
    phoneCode: '+358',
    name: 'Finland',
    native: 'Suomi',
    vat: 24,
  },
  {
    code2: 'FR',
    code3: 'FRA',
    currency: 'EUR',
    phoneCode: '+33',
    name: 'France',
    native: 'France',
    vat: 20,
  },
  {
    code2: 'GF',
    code3: 'GUF',
    currency: 'USD',
    phoneCode: '+594',
    name: 'French Guiana',
    native: 'Guyane française',
    vat: 14,
  },
  {
    code2: 'PF',
    code3: 'PYF',
    currency: 'USD',
    phoneCode: '+689',
    name: 'French Polynesia',
    native: 'Polynésie française',
    vat: 16,
  },
  {
    code2: 'GA',
    code3: 'GAB',
    currency: 'USD',
    phoneCode: '+241',
    name: 'Gabon',
    native: 'Gabon',
    vat: 18,
  },
  {
    code2: 'GM',
    code3: 'GMB',
    currency: 'USD',
    phoneCode: '+220',
    name: 'Gambia',
    native: 'Gambia',
    vat: 15,
  },
  {
    code2: 'GE',
    code3: 'GEO',
    currency: 'USD',
    phoneCode: '+995',
    name: 'Georgia',
    native: 'საქართველო',
    vat: 18,
  },
  {
    code2: 'DE',
    code3: 'DEU',
    currency: 'EUR',
    phoneCode: '+49',
    name: 'Germany',
    native: 'Deutschland',
    vat: 19,
    priority: 1,
  },
  {
    code2: 'GH',
    code3: 'GHA',
    currency: 'USD',
    phoneCode: '+233',
    name: 'Ghana',
    native: 'Ghana',
    vat: 12.5,
  },
  {
    code2: 'GR',
    code3: 'GRC',
    currency: 'EUR',
    phoneCode: '+30',
    name: 'Greece',
    native: 'Ελλάδα',
    vat: 12.5,
  },
  {
    code2: 'GD',
    code3: 'GRD',
    currency: 'USD',
    phoneCode: '+1',
    name: 'Grenada',
    native: 'Grenada',
    vat: 15,
  },
  {
    code2: 'GP',
    code3: 'GLP',
    currency: 'USD',
    phoneCode: '+590',
    name: 'Guadeloupe',
    native: 'Guadeloupe',
    vat: 8.5,
  },
  {
    code2: 'GU',
    code3: 'GUM',
    currency: 'USD',
    phoneCode: '+1',
    name: 'Guam',
    native: 'Guam',
    vat: 2,
  },
  {
    code2: 'GT',
    code3: 'GTM',
    currency: 'USD',
    phoneCode: '+502',
    name: 'Guatemala',
    native: 'Guatemala',
    vat: 12,
  },
  {
    code2: 'GN',
    code3: 'GIN',
    currency: 'USD',
    phoneCode: '+224',
    name: 'Guinea',
    native: 'Guinée',
    vat: 18,
  },
  {
    code2: 'GW',
    code3: 'GNB',
    currency: 'USD',
    phoneCode: '+245',
    name: 'Guinea-Bissau',
    native: 'Guiné-Bissau',
    vat: 15,
  },
  {
    code2: 'GY',
    code3: 'GUY',
    currency: 'USD',
    phoneCode: '+592',
    name: 'Guyana',
    native: 'Guyana',
    vat: 14,
  },
  // {
  //   code2: 'HT',
  //   code3: 'HTI',
  //   currency: 'USD',
  //   phoneCode: '+509',
  //   name: 'Haiti',
  //   native: 'Haïti',
  //   vat: 10,
  // },
  {
    code2: 'HN',
    code3: 'HND',
    currency: 'USD',
    phoneCode: '+504',
    name: 'Honduras',
    native: 'Honduras',
    vat: 15,
  },
  {
    code2: 'HU',
    code3: 'HUN',
    currency: 'HUF',
    phoneCode: '+36',
    name: 'Hungary',
    native: 'Magyarország',
    vat: 27,
  },
  {
    code2: 'IS',
    code3: 'ISL',
    currency: 'EUR',
    phoneCode: '+354',
    name: 'Iceland',
    native: 'Ísland',
    vat: 24,
  },
  {
    code2: 'IN',
    code3: 'IND',
    currency: 'USD',
    phoneCode: '+91',
    name: 'India',
    native: 'भारत',
    vat: 8,
  },
  {
    code2: 'ID',
    code3: 'IDN',
    currency: 'USD',
    phoneCode: '+62',
    name: 'Indonesia',
    native: 'Indonesia',
    vat: 10,
  },
  // {
  //   code2: 'IR',
  //   code3: 'IRN',
  //   currency: 'USD',
  //   phoneCode: '+98',
  //   name: 'Iran',
  //   native: 'ایران',
  //   vat: 9,
  // },
  {
    code2: 'IQ',
    code3: 'IRQ',
    currency: 'USD',
    phoneCode: '+964',
    name: 'Iraq',
    native: 'العراق',
    vat: 15,
  },
  {
    code2: 'IE',
    code3: 'IRL',
    currency: 'EUR',
    phoneCode: '+353',
    name: 'Ireland',
    native: 'Éire',
    vat: 23,
  },
  {
    code2: 'IM',
    code3: 'IMN',
    currency: 'GBP',
    phoneCode: '+44',
    name: 'Isle of Man',
    native: 'Isle of Man',
    vat: 20,
  },
  {
    code2: 'IL',
    code3: 'ISR',
    currency: 'USD',
    phoneCode: '+972',
    name: 'Israel',
    native: 'יִשְׂרָאֵל',
    vat: 17,
  },
  {
    code2: 'IT',
    code3: 'ITA',
    currency: 'EUR',
    phoneCode: '+39',
    name: 'Italy',
    native: 'Italia',
    vat: 22,
  },
  {
    code2: 'CI',
    code3: 'CIV',
    currency: 'USD',
    phoneCode: '+225',
    name: 'Ivory Coast',
    native: 'Côte d\'Ivoire',
    vat: 18,
  },
  // {
  //   code2: 'JM',
  //   code3: 'JAM',
  //   currency: 'USD',
  //   phoneCode: '+1',
  //   name: 'Jamaica',
  //   native: 'Jamaica',
  //   vat: 20,
  // },
  {
    code2: 'JP',
    code3: 'JPN',
    currency: 'USD',
    phoneCode: '+81',
    name: 'Japan',
    native: '日本',
    vat: 10,
  },
  {
    code2: 'JE',
    code3: 'JEY',
    currency: 'USD',
    phoneCode: '+44',
    name: 'Jersey',
    native: 'Jersey',
    vat: 5,
  },
  {
    code2: 'JO',
    code3: 'JOR',
    currency: 'USD',
    phoneCode: '+962',
    name: 'Jordan',
    native: 'الأردن',
    vat: 16,
  },
  {
    code2: 'KZ',
    code3: 'KAZ',
    currency: 'USD',
    phoneCode: '+7',
    name: 'Kazakhstan',
    native: 'Қазақстан',
    vat: 12,
  },
  {
    code2: 'KE',
    code3: 'KEN',
    currency: 'USD',
    phoneCode: '+254',
    name: 'Kenya',
    native: 'Kenya',
    vat: 16,
  },
  {
    code2: 'KI',
    code3: 'KIR',
    currency: 'USD',
    phoneCode: '+686',
    name: 'Kiribati',
    native: 'Kiribati',
    vat: 12.5,
  },
  {
    code2: 'XK',
    code3: 'XKX',
    currency: 'EUR',
    phoneCode: '+383',
    name: 'Kosovo',
    native: 'Republika e Kosovës',
    vat: 18,
  },
  {
    code2: 'KW',
    code3: 'KWT',
    currency: 'USD',
    phoneCode: '+965',
    name: 'Kuwait',
    native: 'الكويت',
    vat: 5,
  },
  {
    code2: 'KG',
    code3: 'KGZ',
    currency: 'USD',
    phoneCode: '+996',
    name: 'Kyrgyzstan',
    native: 'Кыргызстан',
    vat: 12,
  },
  {
    code2: 'LA',
    code3: 'LAO',
    currency: 'USD',
    phoneCode: '+856',
    name: 'Laos',
    native: 'ສປປລາວ',
    vat: 10,
  },
  {
    code2: 'LV',
    code3: 'LVA',
    currency: 'EUR',
    phoneCode: '+371',
    name: 'Latvia',
    native: 'Latvija',
    vat: 21,
  },
  {
    code2: 'LB',
    code3: 'LBN',
    currency: 'USD',
    phoneCode: '+961',
    name: 'Lebanon',
    native: 'لبنان',
    vat: 11,
  },
  {
    code2: 'LS',
    code3: 'LSO',
    currency: 'USD',
    phoneCode: '+266',
    name: 'Lesotho',
    native: 'Lesotho',
    vat: 15,
  },
  {
    code2: 'LR',
    code3: 'LBR',
    currency: 'USD',
    phoneCode: '+231',
    name: 'Liberia',
    native: 'Liberia',
    vat: 10,
  },
  {
    code2: 'LI',
    code3: 'LIE',
    currency: 'EUR',
    phoneCode: '+423',
    name: 'Liechtenstein',
    native: 'Liechtenstein',
    vat: 7.7,
  },
  {
    code2: 'LT',
    code3: 'LTU',
    currency: 'EUR',
    phoneCode: '+370',
    name: 'Lithuania',
    native: 'Lietuva',
    vat: 21,
  },
  {
    code2: 'LU',
    code3: 'LUX',
    currency: 'EUR',
    phoneCode: '+352',
    name: 'Luxembourg',
    native: 'Luxembourg',
    vat: 17,
  },
  {
    code2: 'MK',
    code3: 'MKD',
    currency: 'EUR',
    phoneCode: '+389',
    name: 'Macedonia',
    native: 'Северна Македонија',
    vat: 18,
  },
  {
    code2: 'MG',
    code3: 'MDG',
    currency: 'USD',
    phoneCode: '+261',
    name: 'Madagascar',
    native: 'Madagasikara',
    vat: 20,
  },
  {
    code2: 'MW',
    code3: 'MWI',
    currency: 'USD',
    phoneCode: '+265',
    name: 'Malawi',
    native: 'Malawi',
    vat: 16.5,
  },
  {
    code2: 'MY',
    code3: 'MYS',
    currency: 'USD',
    phoneCode: '+60',
    name: 'Malaysia',
    native: 'Malaysia',
    vat: 6,
  },
  {
    code2: 'MV',
    code3: 'MDV',
    currency: 'USD',
    phoneCode: '+960',
    name: 'Maldives',
    native: 'Maldives',
    vat: 6,
  },
  // {
  //   code2: 'ML',
  //   code3: 'MLI',
  //   currency: 'USD',
  //   phoneCode: '+223',
  //   name: 'Mali',
  //   native: 'Mali',
  //   vat: 18,
  // },
  {
    code2: 'MT',
    code3: 'MLT',
    currency: 'EUR',
    phoneCode: '+356',
    name: 'Malta',
    native: 'Malta',
    vat: 18,
  },
  {
    code2: 'MQ',
    code3: 'MTQ',
    currency: 'USD',
    phoneCode: '+596',
    name: 'Martinique',
    native: 'Martinique',
    vat: 8.5,
  },
  {
    code2: 'MR',
    code3: 'MRT',
    currency: 'USD',
    phoneCode: '+222',
    name: 'Mauritania',
    native: 'موريتانيا',
    vat: 16,
  },
  {
    code2: 'MU',
    code3: 'MUS',
    currency: 'USD',
    phoneCode: '+230',
    name: 'Mauritius',
    native: 'Maurice',
    vat: 15,
  },
  {
    code2: 'MX',
    code3: 'MEX',
    currency: 'USD',
    phoneCode: '+52',
    name: 'Mexico',
    native: 'México',
    vat: 16,
  },
  {
    code2: 'FM',
    code3: 'FSM',
    currency: 'USD',
    phoneCode: '+691',
    name: 'Micronesia',
    native: 'Micronesia',
    vat: 5,
  },
  {
    code2: 'MD',
    code3: 'MDA',
    currency: 'EUR',
    phoneCode: '+373',
    name: 'Moldova',
    native: 'Moldova',
    vat: 20,
  },
  {
    code2: 'MC',
    code3: 'MCO',
    currency: 'EUR',
    phoneCode: '+377',
    name: 'Monaco',
    native: 'Monaco',
    vat: 20,
  },
  {
    code2: 'MN',
    code3: 'MNG',
    currency: 'USD',
    phoneCode: '+976',
    name: 'Mongolia',
    native: 'Монгол улс',
    vat: 10,
  },
  {
    code2: 'ME',
    code3: 'MNE',
    currency: 'EUR',
    phoneCode: '+382',
    name: 'Montenegro',
    native: 'Црна Гора',
    vat: 21,
  },
  {
    code2: 'MS',
    code3: 'MSR',
    currency: 'USD',
    phoneCode: '+664',
    name: 'Montserrat',
    native: 'Montserrat',
    vat: 15,
  },
  {
    code2: 'MA',
    code3: 'MAR',
    currency: 'USD',
    phoneCode: '+212',
    name: 'Morocco',
    native: 'المغرب',
    vat: 20,
  },
  // {
  //   code2: 'MZ',
  //   code3: 'MOZ',
  //   currency: 'USD',
  //   phoneCode: '+258',
  //   name: 'Mozambique',
  //   native: 'Moçambique',
  //   vat: 17,
  // },
  {
    code2: 'NA',
    code3: 'NAM',
    currency: 'USD',
    phoneCode: '+264',
    name: 'Namibia',
    native: 'Namibia',
    vat: 15,
  },
  {
    code2: 'NP',
    code3: 'NPL',
    currency: 'USD',
    phoneCode: '+977',
    name: 'Nepal',
    native: 'नेपाल',
    vat: 13,
  },
  {
    code2: 'NL',
    code3: 'NLD',
    currency: 'EUR',
    phoneCode: '+31',
    name: 'Netherlands',
    native: 'Nederland',
    vat: 21,
  },
  {
    code2: 'NZ',
    code3: 'NZL',
    currency: 'USD',
    phoneCode: '+64',
    name: 'New Zealand',
    native: 'New Zealand',
    vat: 15,
  },
  {
    code2: 'NI',
    code3: 'NIC',
    currency: 'USD',
    phoneCode: '+505',
    name: 'Nicaragua',
    native: 'Nicaragua',
    vat: 15,
  },
  {
    code2: 'NE',
    code3: 'NER',
    currency: 'USD',
    phoneCode: '+227',
    name: 'Niger',
    native: 'Niger',
    vat: 19,
  },
  // {
  //   code2: 'NG',
  //   code3: 'NGA',
  //   currency: 'USD',
  //   phoneCode: '+234',
  //   name: 'Nigeria',
  //   native: 'Nigeria',
  //   vat: 7.5,
  // },
  {
    code2: 'NU',
    code3: 'NIU',
    currency: 'USD',
    phoneCode: '+683',
    name: 'Niue',
    native: 'Niuē',
    vat: 12.5,
  },
  {
    code2: 'NF',
    code3: 'NFK',
    currency: 'USD',
    phoneCode: '+672',
    name: 'Norfolk Island',
    native: 'Norfolk Island',
    vat: 12,
  },
  // {
  //   code2: 'KP',
  //   code3: 'PRK',
  //   currency: 'USD',
  //   phoneCode: '+850',
  //   name: 'North Korea',
  //   native: '북한',
  //   vat: 10,
  // },
  {
    code2: 'NO',
    code3: 'NOR',
    currency: 'EUR',
    phoneCode: '+47',
    name: 'Norway',
    native: 'Norge',
    vat: 25,
  },
  {
    code2: 'OM',
    code3: 'OMN',
    currency: 'USD',
    phoneCode: '+968',
    name: 'Oman',
    native: 'عمان',
    vat: 5,
  },
  {
    code2: 'PK',
    code3: 'PAK',
    currency: 'USD',
    phoneCode: '+92',
    name: 'Pakistan',
    native: 'Pakistan',
    vat: 17,
  },
  {
    code2: 'PS',
    code3: 'PSE',
    currency: 'USD',
    phoneCode: '+970',
    name: 'Palestine',
    native: 'فلسطين',
    vat: 16,
  },
  // {
  //   code2: 'PA',
  //   code3: 'PAN',
  //   currency: 'USD',
  //   phoneCode: '+507',
  //   name: 'Panama',
  //   native: 'Panamá',
  //   vat: 7,
  // },
  {
    code2: 'PG',
    code3: 'PNG',
    currency: 'USD',
    phoneCode: '+675',
    name: 'Papua New Guinea',
    native: 'Papua Niugini',
    vat: 10,
  },
  {
    code2: 'PY',
    code3: 'PRY',
    currency: 'USD',
    phoneCode: '+595',
    name: 'Paraguay',
    native: 'Paraguay',
    vat: 10,
  },
  {
    code2: 'PE',
    code3: 'PER',
    currency: 'USD',
    phoneCode: '+51',
    name: 'Peru',
    native: 'Perú',
    vat: 18,
  },
  // {
  //   code2: 'PH',
  //   code3: 'PHL',
  //   currency: 'USD',
  //   phoneCode: '+63',
  //   name: 'Philippines',
  //   native: 'Pilipinas',
  //   vat: 12,
  // },
  {
    code2: 'PL',
    code3: 'POL',
    currency: 'PLN',
    phoneCode: '+48',
    name: 'Poland',
    native: 'Polska',
    vat: 23,
    priority: 1,
  },
  {
    code2: 'PT',
    code3: 'PRT',
    currency: 'EUR',
    phoneCode: '+351',
    name: 'Portugal',
    native: 'Portugal',
    vat: 23,
  },
  {
    code2: 'PR',
    code3: 'PRI',
    currency: 'USD',
    phoneCode: '+1',
    name: 'Puerto Rico',
    native: 'Puerto Rico',
    vat: 11.5,
  },
  {
    code2: 'QA',
    code3: 'QAT',
    currency: 'USD',
    phoneCode: '+974',
    name: 'Qatar',
    native: 'قطر',
    vat: 5,
  },
  {
    code2: 'CG',
    code3: 'COG',
    currency: 'USD',
    phoneCode: '+242',
    name: 'Republic of the Congo',
    native: 'République du Congo',
    vat: 18,
  },
  {
    code2: 'RE',
    code3: 'REU',
    currency: 'USD',
    phoneCode: '+262',
    name: 'Réunion',
    native: 'La Réunion',
    vat: 8.5,
  },
  {
    code2: 'RO',
    code3: 'ROU',
    currency: 'RON',
    phoneCode: '+40',
    name: 'Romania',
    native: 'România',
    vat: 19,
  },
  // {
  //   code2: 'RU',
  //   code3: 'RUS',
  //   currency: 'RUB',
  //   phoneCode: '+7',
  //   name: 'Russia',
  //   native: 'Россия',
  //   vat: 20,
  // },
  {
    code2: 'RW',
    code3: 'RWA',
    currency: 'USD',
    phoneCode: '+250',
    name: 'Rwanda',
    native: 'Rwanda',
    vat: 18,
  },
  {
    code2: 'BL',
    code3: 'BLM',
    currency: 'USD',
    phoneCode: '+590',
    name: 'Saint Barthélemy',
    native: 'Saint-Barthélemy',
    vat: 8.5,
  },
  {
    code2: 'KN',
    code3: 'KNA',
    currency: 'USD',
    phoneCode: '+869',
    name: 'Saint Kitts and Nevis',
    native: 'Saint Kitts and Nevis',
    vat: 17,
  },
  {
    code2: 'LC',
    code3: 'LCA',
    currency: 'USD',
    phoneCode: '+1',
    name: 'Saint Lucia',
    native: 'Saint Lucia',
    vat: 12.5,
  },
  {
    code2: 'MF',
    code3: 'MAF',
    currency: 'USD',
    phoneCode: '+590',
    name: 'Saint Martin',
    native: 'Saint-Martin',
    vat: 15,
  },
  {
    code2: 'VC',
    code3: 'VCT',
    currency: 'USD',
    phoneCode: '+1',
    name: 'Saint Vincent and the Grenadines',
    native: 'Saint Vincent and the Grenadines',
    vat: 16,
  },
  {
    code2: 'WS',
    code3: 'WSM',
    currency: 'USD',
    phoneCode: '+685',
    name: 'Samoa',
    native: 'Samoa',
    vat: 15,
  },
  {
    code2: 'SM',
    code3: 'SMR',
    currency: 'USD',
    phoneCode: '+378',
    name: 'San Marino',
    native: 'San Marino',
    vat: 17,
  },
  {
    code2: 'SA',
    code3: 'SAU',
    currency: 'USD',
    phoneCode: '+966',
    name: 'Saudi Arabia',
    native: 'العربية السعودية',
    vat: 5,
  },
  // {
  //   code2: 'SN',
  //   code3: 'SEN',
  //   currency: 'USD',
  //   phoneCode: '+221',
  //   name: 'Senegal',
  //   native: 'Sénégal',
  //   vat: 18,
  // },
  {
    code2: 'RS',
    code3: 'SRB',
    currency: 'EUR',
    phoneCode: '+381',
    name: 'Serbia',
    native: 'Србија',
    vat: 20,
  },
  {
    code2: 'SC',
    code3: 'SYC',
    currency: 'USD',
    phoneCode: '+248',
    name: 'Seychelles',
    native: 'Seychelles',
    vat: 15,
  },
  {
    code2: 'SL',
    code3: 'SLE',
    currency: 'USD',
    phoneCode: '+232',
    name: 'Sierra Leone',
    native: 'Sierra Leone',
    vat: 15,
  },
  {
    code2: 'SG',
    code3: 'SGP',
    currency: 'USD',
    phoneCode: '+65',
    name: 'Singapore',
    native: 'Singapore',
    vat: 7,
  },
  {
    code2: 'SX',
    code3: 'SXM',
    currency: 'USD',
    phoneCode: '+1',
    name: 'Sint Maarten',
    native: 'Sint Maarten',
    vat: 5,
  },
  {
    code2: 'SK',
    code3: 'SVK',
    currency: 'EUR',
    phoneCode: '+421',
    name: 'Slovakia',
    native: 'Slovensko',
    vat: 20,
    priority: 1,
  },
  {
    code2: 'SI',
    code3: 'SVN',
    currency: 'EUR',
    phoneCode: '+386',
    name: 'Slovenia',
    native: 'Slovenija',
    vat: 22,
  },
  {
    code2: 'SO',
    code3: 'SOM',
    currency: 'USD',
    phoneCode: '+252',
    name: 'Somalia',
    native: 'Soomaaliya',
    vat: 10,
  },
  // {
  //   code2: 'ZA',
  //   code3: 'ZAF',
  //   currency: 'USD',
  //   phoneCode: '+27',
  //   name: 'South Africa',
  //   native: 'South Africa',
  //   vat: 15,
  // },
  {
    code2: 'KR',
    code3: 'KOR',
    currency: 'USD',
    phoneCode: '+82',
    name: 'South Korea',
    native: '대한민국',
    vat: 10,
  },
  // {
  //   code2: 'SS',
  //   code3: 'SSD',
  //   currency: 'USD',
  //   phoneCode: '+211',
  //   name: 'South Sudan',
  //   native: 'South Sudan',
  //   vat: 15,
  // },
  {
    code2: 'ES',
    code3: 'ESP',
    currency: 'EUR',
    phoneCode: '+34',
    name: 'Spain',
    native: 'España',
    vat: 21,
  },
  {
    code2: 'LK',
    code3: 'LKA',
    currency: 'USD',
    phoneCode: '+94',
    name: 'Sri Lanka',
    native: 'śrī laṃkāva',
    vat: 8,
  },
  {
    code2: 'SD',
    code3: 'SDN',
    currency: 'USD',
    phoneCode: '+249',
    name: 'Sudan',
    native: 'السودان',
    vat: 17,
  },
  {
    code2: 'SR',
    code3: 'SUR',
    currency: 'USD',
    phoneCode: '+597',
    name: 'Suriname',
    native: 'Suriname',
    vat: 10,
  },
  {
    code2: 'SJ',
    code3: 'SJM',
    currency: 'USD',
    phoneCode: '+47',
    name: 'Svalbard and Jan Mayen',
    native: 'Svalbard og Jan Mayen',
    vat: 25,
  },
  {
    code2: 'SZ',
    code3: 'SWZ',
    currency: 'USD',
    phoneCode: '+268',
    name: 'Swaziland',
    native: 'Eswatini',
    vat: 15,
  },
  {
    code2: 'SE',
    code3: 'SWE',
    currency: 'SEK',
    phoneCode: '+46',
    name: 'Sweden',
    native: 'Sverige',
    vat: 25,
  },
  {
    code2: 'CH',
    code3: 'CHE',
    currency: 'CHF',
    phoneCode: '+41',
    name: 'Switzerland',
    native: 'Schweiz',
    vat: 7.7,
  },
  {
    code2: 'TW',
    code3: 'TWN',
    currency: 'USD',
    phoneCode: '+886',
    name: 'Taiwan',
    native: '臺灣',
    vat: 5,
  },
  {
    code2: 'TJ',
    code3: 'TJK',
    currency: 'USD',
    phoneCode: '+992',
    name: 'Tajikistan',
    native: 'Тоҷикистон',
    vat: 15,
  },
  // {
  //   code2: 'TZ',
  //   code3: 'TZA',
  //   currency: 'USD',
  //   phoneCode: '+255',
  //   name: 'Tanzania',
  //   native: 'Tanzania',
  //   vat: 18,
  // },
  {
    code2: 'TH',
    code3: 'THA',
    currency: 'USD',
    phoneCode: '+66',
    name: 'Thailand',
    native: 'ประเทศไทย',
    vat: 7,
  },
  {
    code2: 'TG',
    code3: 'TGO',
    currency: 'USD',
    phoneCode: '+228',
    name: 'Togo',
    native: 'Togo',
    vat: 18,
  },
  {
    code2: 'TO',
    code3: 'TON',
    currency: 'USD',
    phoneCode: '+676',
    name: 'Tonga',
    native: 'Tonga',
    vat: 15,
  },
  // {
  //   code2: 'TT',
  //   code3: 'TTO',
  //   currency: 'USD',
  //   phoneCode: '+868',
  //   name: 'Trinidad and Tobago',
  //   native: 'Trinidad and Tobago',
  //   vat: 12.5,
  // },
  {
    code2: 'TN',
    code3: 'TUN',
    currency: 'USD',
    phoneCode: '+216',
    name: 'Tunisia',
    native: 'تونس',
    vat: 19,
  },
  {
    code2: 'TR',
    code3: 'TUR',
    currency: 'USD',
    phoneCode: '+90',
    name: 'Turkey',
    native: 'Türkiye',
    vat: 18,
  },
  {
    code2: 'TM',
    code3: 'TKM',
    currency: 'USD',
    phoneCode: '+993',
    name: 'Turkmenistan',
    native: 'Türkmenistan',
    vat: 15,
  },
  {
    code2: 'UM',
    code3: 'UMI',
    currency: 'USD',
    phoneCode: '+1',
    name: 'U.S. Minor Outlying Islands',
    native: 'United States Minor Outlying Islands',
    vat: 4,
  },
  {
    code2: 'VI',
    code3: 'VIR',
    currency: 'USD',
    phoneCode: '+1',
    name: 'U.S. Virgin Islands',
    native: 'United States Virgin Islands',
    vat: 4,
  },
  // {
  //   code2: 'UG',
  //   code3: 'UGA',
  //   currency: 'USD',
  //   phoneCode: '+256',
  //   name: 'Uganda',
  //   native: 'Uganda',
  //   vat: 18,
  // },
  {
    code2: 'UA',
    code3: 'UKR',
    currency: 'UAH',
    phoneCode: '+380',
    name: 'Ukraine',
    native: 'Україна',
    vat: 20,
  },
  // {
  //   code2: 'AE',
  //   code3: 'ARE',
  //   currency: 'USD',
  //   phoneCode: '+971',
  //   name: 'United Arab Emirates',
  //   native: 'دولة الإمارات العربية المتحدة',
  //   vat: 5,
  // },
  {
    code2: 'GB',
    code3: 'GBR',
    currency: 'GBP',
    phoneCode: '+44',
    name: 'United Kingdom',
    native: 'United Kingdom',
    vat: 20,
  },
  {
    code2: 'UZ',
    code3: 'UZB',
    currency: 'USD',
    phoneCode: '+998',
    name: 'Uzbekistan',
    native: 'O\'zbekiston',
    vat: 20,
  },
  // {
  //   code2: 'VU',
  //   code3: 'VUT',
  //   currency: 'USD',
  //   phoneCode: '+678',
  //   name: 'Vanuatu',
  //   native: 'Vanuatu',
  //   vat: 15,
  // },
  {
    code2: 'VE',
    code3: 'VEN',
    currency: 'USD',
    phoneCode: '+58',
    name: 'Venezuela',
    native: 'Venezuela',
    vat: 16,
  },
  // {
  //   code2: 'VN',
  //   code3: 'VNM',
  //   currency: 'USD',
  //   phoneCode: '+84',
  //   name: 'Vietnam',
  //   native: 'Việt Nam',
  //   vat: 10,
  // },
  {
    code2: 'WF',
    code3: 'WLF',
    currency: 'USD',
    phoneCode: '+681',
    name: 'Wallis and Futuna',
    native: 'Wallis et Futuna',
    vat: 6,
  },
  {
    code2: 'EH',
    code3: 'ESH',
    currency: 'USD',
    phoneCode: '+212',
    name: 'Western Sahara',
    native: 'الصحراء الغربية',
    vat: 20,
  },
  // {
  //   code2: 'YE',
  //   code3: 'YEM',
  //   currency: 'USD',
  //   phoneCode: '+967',
  //   name: 'Yemen',
  //   native: 'اليَمَن',
  //   vat: 5,
  // },
  {
    code2: 'ZM',
    code3: 'ZMB',
    currency: 'USD',
    phoneCode: '+260',
    name: 'Zambia',
    native: 'Zambia',
    vat: 16,
  },
  {
    code2: 'ZW',
    code3: 'ZWE',
    currency: 'USD',
    phoneCode: '+263',
    name: 'Zimbabwe',
    native: 'Zimbabwe',
    vat: 14.5,
  },
]

export default countries
